export const STOCK_TRANSFER_SOURCE_TYPE_LABELS = {
  MANUAL: '一般轉倉',
  WORK_ORDER: '工單轉倉',
};

export const STOCK_TRANSFER_SOURCE_TYPE_FILTER_OPTIONS = [
  { value: 'MANUAL', label: STOCK_TRANSFER_SOURCE_TYPE_LABELS.MANUAL },
  { value: 'WORK_ORDER', label: STOCK_TRANSFER_SOURCE_TYPE_LABELS.WORK_ORDER },
];

export function formatStockTransferSourceTypeLabel(sourceType) {
  return STOCK_TRANSFER_SOURCE_TYPE_LABELS[sourceType] || sourceType || '-';
}
